@if (dataLoaded) {
    <div menuSystem [cerrixTab]="tab" class="mailmessage-detail">
        <div menuItemId="menuItemMail" [attr.name]="'maintenance.menuMail' | t" menuicon="fas fa-mail-bulk" menusystemsubmenu>
            <div
                menuItemId="menuItemMailmessages"
                [attr.name]="'maintenance.menuMailmessages' | t"
                class="mailmessage-screens"
                menuicon="fas fa-envelope"
                menusystemsubmenu
            >
                @if (permService.permissions.IsApplicationAdmin) {
                    <div
                        [attr.name]="'maintenance.menuApplication' | t"
                        menuicon="fas fa-unlock-alt"
                        menuItemId="application-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.COMMON"
                        ></uc-mailmessages-overview>
                    </div>
                }

                @if (permService.permissions.MailMessages.IsBimMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuBusinessImprovement' | t"
                        menuicon="fas fa-tasks"
                        menuItemId="bi-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.BIM"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if(permService.permissions.MailMessages.IsRiskMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuRisk' | t"
                        menuicon="fas fa-exclamation-triangle"
                        menuItemId="risk-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.ORM"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsControlMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuControl' | t"
                        menuicon="fas fa-shield-alt"
                        menuItemId="control-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.Controls"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsEventMailAdministrator) {
                    <div [attr.name]="'maintenance.menuEvent' | t" menuicon="fas fa-bolt" menuItemId="event-mail" menusystemitem>
                        <uc-mailmessages-overview
                            [module]="moduleTypes.LER"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsFormMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuForms' | t"
                        menuicon="fas fa-file-alt"
                        menuItemId="form-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.FRM"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsInviteMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuInvite' | t"
                        menuicon="fas fa-paper-plane"
                        menuItemId="invite-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.CI"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsNavigatorMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuNavigators' | t"
                        menuicon="fad fa-sitemap"
                        menuItemId="navigator-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.NAV"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsAuditMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuAudit' | t"
                        menuicon="fal fa-clipboard-list-check"
                        menuItemId="audit-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.AUDIT"
                        ></uc-mailmessages-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsTaskMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuTasks' | t"
                        menuicon="fad fa-list-ol"
                        menuItemId="tasks-mail"
                        menusystemitem
                    >
                        <uc-mailmessages-overview
                            [module]="moduleTypes.Tasks"
                        ></uc-mailmessages-overview>
                    </div>
                }
            </div>
            <div
                menuItemId="menuItemNotifications"
                [attr.name]="'maintenance.menuNotifications' | t"
                menuicon="fad fa-bells"
                menusystemsubmenu
            >
                @if (permService.permissions.MailMessages.IsApplicationMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuApplication' | t"
                        menuicon="fas fa-unlock-alt"
                        menuItemId="application-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.COMMON"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsControlMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuControls' | t"
                        menuicon="fas fa-shield-alt"
                        menuItemId="control-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.Controls"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsBimMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuMeasuresOfImprovement' | t"
                        menuicon="fas fa-tasks"
                        menuItemId="moi-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.IM"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsFormMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuForms' | t"
                        menuicon="fas fa-file-alt"
                        menuItemId="form-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.FRM"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsThirdPartyMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuThirdParty' | t"
                        menuicon="fas fa-handshake"
                        menuItemId="tp-notification-mail"
                        menusystemitem
                    >
                        <uc-notification-overview
                            [module]="moduleTypes.TP"
                        ></uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsNavigatorMailAdministrator) {
                    <div
                        menuItemId="menuItemNotificationNavigators"
                        [attr.name]="'maintenance.menuNavigators' | t"
                        menuicon="fad fa-sitemap"
                        menusystemitem
                    >
                        <uc-notification-overview [module]="moduleTypes.NAV">
                        </uc-notification-overview>
                    </div>
                }
                @if (permService.permissions.MailMessages.IsTaskMailAdministrator) {
                    <div
                        menuItemId="menuItemNotificationTasks"
                        [attr.name]="'maintenance.menuTasks' | t"
                        menuicon="fad fa-list-ol"
                        menusystemitem
                    >
                        <uc-notification-overview [module]="moduleTypes.Tasks">
                        </uc-notification-overview>
                    </div>
                }
            </div>
            <div
                menuItemId="menuItemPeriodicNotifications"
                [attr.name]="'maintenance.menuPeriodicNotifications' | t"
                menuicon="fad fa-bells"
                menusystemsubmenu
            >
                @if (permService.permissions.MailMessages.IsBimMailAdministrator) {
                    <div
                        [attr.name]="'maintenance.menuMeasuresOfImprovement' | t"
                        menuicon="fas fa-tasks"
                        menuItemId="moi-periodic-notification-mail"
                        menusystemitem
                    >
                        <uc-periodic-notification-overview
                            [module]="moduleTypes.IM"
                        ></uc-periodic-notification-overview>
                    </div>
                }
                @if (
                    useIncidents && permService.permissions.MailMessages.IsEventMailAdministrator
                ) {
                    <div
                        [attr.name]="'maintenance.menuIncidents' | t"
                        menuicon="fas fa-bolt"
                        menuItemId="incidents-periodic-notification-mail"
                        menusystemitem
                    >
                        <uc-periodic-notification-overview
                            [module]="moduleTypes.Incidents"
                        ></uc-periodic-notification-overview>
                    </div>
                }
            </div>
            @if (permService.permissions.IsApplicationAdmin || hasViewEmailsDataAccess()) {
                <div
                    menuItemId="menuItemSentMails"
                    [attr.name]="'maintenance.menuSentMailsGroup' | t"
                    menuicon="fad fa-history"
                    menusystemsubmenu
                >
                    @if (permService.permissions.IsApplicationAdmin) {
                        <div
                            [attr.name]="'maintenance.menuSentMails' | t"
                            class="sent-mails"
                            menuItemId="sent-mails"
                            menuicon="fas fa-envelope"
                            menusystemitem
                        >
                            <uc-sentnotification-overview
                                [parentTab]="tab"
                                #sentmails
                            ></uc-sentnotification-overview>
                        </div>
                    }
                    @if (hasViewEmailsDataAccess()) {
                        <div
                            [attr.name]="'maintenance.menuIncidentSentMails' | t"
                            class="incident-sent-mails"
                            menuItemId="incident-sent-mails"
                            menuicon="fas fa-bolt"
                            menusystemitem
                        >
                            <incident-sent-emails></incident-sent-emails>
                        </div>
                    }
                </div>
            }
            @if (permService.permissions.IsApplicationAdmin) {
                <div
                    [attr.name]="'maintenance.menuNotificationSettings' | t"
                    class="notification-settings"
                    menuItemId="notification-settings"
                    menuicon="fas fa-cogs"
                    menusystemitem
                >
                    <notification-settings
                        [parentTab]="tab"
                        #notificationSettings
                    ></notification-settings>
                </div>
            }
        </div>
    </div>
}
